import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
// import ReactPlayer from 'react-player';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import TypoFramed from '../../components/TypoFramed';
import { ReactComponent as Play } from '../../res/play.svg';
import { ReactComponent as Add } from '../../res/add.svg';
import ButtonWithIcon from '../../components/ButtonWithIcon';
import PopupEmmanuelleCosse from '../../popups/PopupEmmanuelleCosse';
import PopupInterview from '../../components/PopupInterview';

import styles from './styles';

class B2EmmanuelleCosse extends React.Component {
  renderBackground() {
    const { classes } = this.props;
    return (
      <div className={classes.background}>
        <div className={classes.bgImg}></div>
        <div className={classes.blur}></div>
        <div className={classes.roofShapeImg}></div>
        <div className={classes.greyCurve}></div>
      </div>
    );
  }

  renderContent() {
    const { classes, data, baseUrl, onPopup } = this.props;
    const title = parse(data.blocks.b2emmanuellecosse.title);
    const subtitle = parse(data.blocks.b2emmanuellecosse.subtitle);
    const desc = parse(data.blocks.b2emmanuellecosse.desc);
    const buttonText = parse(data.blocks.b2emmanuellecosse.buttonText);
    const imgSrc = `${baseUrl}/blocks/${data.blocks.b2emmanuellecosse.preview}`;
    // const preview = `${baseUrl}/blocks/${data.blocks.b2emmanuellecosse.preview}`;
    // const interviewUrl = parse(data.blocks.b2emmanuellecosse.interviewUrl);
    return (
      <div className={classes.content}>
        <div className={classes.main}>
          {/* <img key="img" src={imgSrc} alt="" className={`${classes.image} ${classes.wrapperPlayer}`} /> */}
          <div className={classes.column}>
            <Typography variant="h2" className={`${classes.title} ${classes.yellow}`}>
              {title}
            </Typography>
            <TypoFramed variant="body1" frame="black">
              {subtitle}
            </TypoFramed>
            <Typography variant="body1" color="secondary" className={classes.desc}>
              {desc}
            </Typography>
            <ButtonWithIcon
              icon={<Add />}
              color="white"
              iconPosition="center"
              className={classes.button}
              onClick={() => onPopup('popupEmmanuelleCosse', true)}
            >
              {buttonText}
            </ButtonWithIcon>
          </div>
          <div className={classes.wrapperPlayer}>
            <img
              key="img"
              role="presentation"
              src={imgSrc}
              alt=""
              onClick={() => onPopup('popupItvEmmanuelleCosse', true)}
              className={classes.image}
            />
            <Play className={classes.playIcon} />
            {/* <ReactPlayer
              light={preview}
              url={interviewUrl}
              playIcon={<Play className={classes.playIcon} />}
              width="100%"
              height="100%"
              playing
              controls
              className={classes.player}
            /> */}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { classes, data, baseUrl, popupsState, onPopup } = this.props;
    const mainTitle = parse(data.blocks.b2emmanuellecosse.mainTitle);
    return (
      <div className={classes.blockContainer}>
        <Typography variant="h1" color="secondary" className={classes.mainTitle}>
          {mainTitle}
        </Typography>
        {this.renderBackground()}
        {this.renderContent()}
        <PopupEmmanuelleCosse
          data={data}
          open={!!popupsState.popupEmmanuelleCosse}
          baseUrl={baseUrl}
          onClose={() => onPopup('popupEmmanuelleCosse', false)}
        ></PopupEmmanuelleCosse>
        <PopupInterview
          data={data}
          baseUrl={baseUrl}
          interview={data.popup.emmanuelleCosse}
          open={!!popupsState.popupItvEmmanuelleCosse}
          onClose={() => onPopup('popupItvEmmanuelleCosse', false)}
        ></PopupInterview>
      </div>
    );
  }
}

B2EmmanuelleCosse.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object,
  baseUrl: PropTypes.string,
  popupsState: PropTypes.object,
  onPopup: PropTypes.func,
};

export default withStyles(styles)(B2EmmanuelleCosse);
